// One sentence for every AI surface's HTTP 429 (the legacy assistant's
// per-IP budget, the personal agent's per-user plan budget);
// `retryAfterSeconds` is the Retry-After header value, null when the backend
// sent none.
export default function assistantRateLimitCopy(
  retryAfterSeconds: number | null,
): string {
  if (retryAfterSeconds === null)
    return "You've reached the AI usage limit. Try again in a few minutes.";
  return `You've reached the AI usage limit. Try again in about ${Math.max(1, Math.ceil(retryAfterSeconds / 60))} min.`;
}
